/**
 * consts to identify certain html items, you can use this for html attrs like name or id
 */
export const BACK_BTN = 'back_btn'
export const NEXT_BTN = 'next_btn'
export const SUBMIT_BTN = 'submit_btn'
export const EXIT_BTN = 'exit_btn'
export const CALLMEBACK_BTN = 'callmeback_btn'
export const PHONE_LINK = 'phone_link'
